import { Sidebar } from 'primereact/sidebar';
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash'
import ProInputText from "../../components/common/ProInputText";
import { useFormik } from "formik";
import { Button } from 'primereact/button';
import ProCheckBox from "../../components/common/ProCheckbox";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { GetBedTypes, AddBedType } from '../../redux/actions/SettingAction'
import { SuccessToast, ErrorToast } from '../../redux/actions/ToasterAction';
import { ShowSpinner, HideSpinner } from '../../redux/actions/SpinnerAction';
import { Menu } from 'primereact/menu';
import ProTextArea from "../../components/common/ProTextArea";
import {duplicateCheck} from "../../utilities/Helper"

const initialState = {
    name: '',
    description: '',
    isActive: true,
    isDefault: false
};
const ManageBedTypes = ({ globalFilter, toggleSideBar, addNew }) => {   
    const [formData, setFormData] = useState(initialState)
    const [headingText, setHeadingText] = useState('Add New Bed Type');

    let items = [
        { label: 'Edit', icon: 'fas fa-edit', command: (e) => { onEdit(e) } },
    ];

    const allBedTypes = useSelector((state) => {
        return state.setting.allBedTypes;
    })

    const dispatch = useDispatch();
    const GetAllBedTypes = useCallback(async (node, data) => {
        dispatch(ShowSpinner());
        var action = await GetBedTypes();
        dispatch(action);
        dispatch(HideSpinner());
        //dispatch(SuccessToast('Success', 'Updated Successfully!'));

    }, [dispatch])


    useEffect(() => {
        GetAllBedTypes();
    }, [GetAllBedTypes]);

    const onEdit = (e) => {
        setFormData(e.item.data)
        setHeadingText('Edit Bed Type');
        addNew()
    }

    const toggleMenu = (menu, event, rowData) => {
        items.forEach((menuItem) => {
            menuItem.data = rowData;
        });
        menu && menu.toggle(event);
    }

    const actionBodyTemplate = (rowData) => {
        return (
            // rowData.isEditable &&
            <React.Fragment>
                <i className="pi pi-ellipsis-h" onClick={(event) => toggleMenu(rowData.menuRef, event, rowData)}></i>
                <Menu model={items} popup ref={(el) => rowData.menuRef = el} />
            </React.Fragment>
        );
    }

    const formik = useFormik({
        initialValues: formData,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (_.isEmpty(_.trim(data.name))) {
                errors.name = `Name is required.`;
            }
            if (!_.isEmpty(data.name) && data.name.length > 120) {
                errors.name = "Max 120 characters allowed";
            }
            if (!_.isEmpty(data.name) && duplicateCheck(allBedTypes,'name', data)) {
                errors.name = "Bed type name already exists!";
            }
            if (!_.isEmpty(data.description) && data.description.length > 500) {
                errors.description = "Max 500 characters allowed";
            }
            return errors;
        },
        onSubmit: (data) => {
            handleSubmit(data);
        },
    });
    const resetFormik = useCallback(() => {
        setFormData(initialState)
        formik.resetForm()
        addNew();
        setHeadingText('Add New Bed Type');
    },[formik, addNew])

    const handleSubmit = useCallback(async (data) => {
        try {
            data = _.omit(data, ['menuRef']);
            data.name =_.trim(data.name);
            dispatch(ShowSpinner());
            var action = await AddBedType(data);
            dispatch(action);
            dispatch(HideSpinner());
            if(data.id){
                dispatch(SuccessToast('Success', 'Updated Successfully!'));
            } else {
                dispatch(SuccessToast('Success', 'Saved Successfully!'));
            }
            GetAllBedTypes();
        }
        catch(err) {
            dispatch(HideSpinner());
            dispatch(ErrorToast('Error', _.get(err, 'response.data.message')));
        }
        resetFormik()
    }, [dispatch, GetAllBedTypes, resetFormik])
    return (<div>
        <Sidebar dismissable={false} modal={false}
            visible={toggleSideBar} position="right"
            style={{ width: '30em', zIndex: 1103 }} onHide={() => resetFormik()} icons={() => (
                <h6 className="p-sidebar-close"
                    style={{
                        fontWeight: '700', fontSize: '20px', width: '100%',
                        margin: 'auto'
                    }}>{headingText}</h6>
            )}>
            <form onSubmit={formik.handleSubmit}>
                <ProInputText
                    headerText="Name"
                    id="name"
                    labelText="Name"
                    formik={formik}
                    name="name"
                    error="name"
                    required
                    value={formik.values.name}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, name: e.target.value });
                    }}
                />
                <ProTextArea
                    rows={7} cols={30}
                    headerText="Description"
                    id="description"
                    labelText="Description"
                    value={formik.values.description}
                    formik={formik}
                    name="description"
                    error="description"
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, description: e.target.value });
                    }}
                />
                <ProCheckBox
                    id="isActive"
                    name="isActive"
                    labelText="Active"
                    checked={formik.values.isActive}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, isActive: e.target.checked, isDefault: !e.target.checked ? false:formik.values.isDefault});
                    }}
                />
                <ProCheckBox
                    className="p-disabled"
                    id="isDefault"
                    disabled={!formik.values.isActive}
                    name="isDefault"
                    labelText="Default"
                    checked={formik.values.isDefault}
                    onChange={(e) => {
                        formik.setValues({ ...formik.values, isDefault: e.target.checked });
                    }}
                />
                <div className="p-d-flex p-jc-start" style={{ marginTop: "25px" }}>
                    <Button label="Cancel" type="button" className="p-button-text" onClick={() => { resetFormik() }} style={{ color: "#34436d" }} />
                    <Button label="Save" type="submit" style={{ backgroundColor: "#34436d" }} />
                </div>
            </form>
        </Sidebar>

        <DataTable value={allBedTypes}
            dataKey="id"
            breakpoint="960px"
            header="Bed Types"
            globalFilter={globalFilter}
            responsiveLayout="stack">
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column> */}
            <Column field="name" header="Name" sortable></Column>
            <Column field="description" header="Description" sortable style={{ width: '30%' }}></Column>
            <Column field="isActive"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.isActive ? 'active' : 'inactive'}`}>{rowData.isActive ? 'Active' : 'Inactive'}</span>;
                }}
                header="Active" sortable></Column>
            <Column field="isDefault"
                body={(rowData) => {
                    return <span className={`table-badge status-${rowData.isDefault ? 'active' : 'inactive'}`}>{rowData.isDefault ? 'Yes' : 'No'}</span>;
                }}
                header="Default" sortable></Column>
            <Column body={actionBodyTemplate} style={{ width: '5%' }}></Column>
        </DataTable>
    </div>)

}

export default ManageBedTypes;